<template>
  <div>
    <Modal
      v-model="show"
      :title="$t('info')"
      :mask-closable="false"
      width="1050"
      @on-cancel="cancel"
    >
      <div class="modal">
        <Form ref="form" :model="form" :label-width="140" label-colon>
          <Tabs :value="tabs" @on-click="ontabs" :animated="false">
            <Row :gutter="15" class="list">
              <Col span="12">
                <TabPane :label="$t('Langue.zn')" name="1">
                  <FormItem class="item_input" :label="$t('cent.name')">
                    <span>{{form['zh-cn_cname']}}</span>
                  </FormItem>
                  <FormItem :label="$t('img_lnk')+' - PC'">
                    <div class="demo-upload-list" v-if="form['zh-cn_image'] != ''">
                      <template>
                        <img :src="form['zh-cn_image']" />
                      </template>
                    </div>
                  </FormItem>
                  <FormItem :label="$t('img_lnk')+' - Mobile'">
                    <div class="demo-upload-list" v-if="form['zh-cn_mobile_img'] != ''">
                      <template>
                        <img :src="form['zh-cn_mobile_img']" />
                      </template>
                    </div>
                  </FormItem>
                </TabPane>
                <TabPane :label="$t('Langue.tw')" name="2">
                  <FormItem class="item_input" :label="$t('cent.name')">
                    <span>{{form['zh-tw_cname']}}</span>
                  </FormItem>
                  <FormItem :label="$t('img_lnk')+' - PC'">
                    <div class="demo-upload-list" v-if="form['zh-tw_image']!= ''">
                      <template>
                        <img :src="form['zh-tw_image']" />
                      </template>
                    </div>
                  </FormItem>
                  <FormItem :label="$t('img_lnk')+' - Mobile'">
                    <div class="demo-upload-list" v-if="form['zh-tw_mobile_img']!= ''">
                      <template>
                        <img :src="form['zh-tw_mobile_img']" />
                      </template>
                    </div>
                  </FormItem>
                </TabPane>
                <TabPane :label="$t('Langue.en')" name="3">
                  <FormItem class="item_input" :label="$t('cent.name')">
                    <span>{{form.en_cname}}</span>
                  </FormItem>
                  <FormItem :label="$t('img_lnk')+' - PC'">
                    <div class="demo-upload-list" v-if="form.en_image != ''">
                      <template>
                        <img :src="form.en_image" />
                      </template>
                    </div>
                  </FormItem>
                  <FormItem :label="$t('img_lnk')+' - Mobile'">
                    <div class="demo-upload-list" v-if="form.en_mobile_img != ''">
                      <template>
                        <img :src="form.en_mobile_img" />
                      </template>
                    </div>
                  </FormItem>
                </TabPane>
              </Col>
              <Col span="12">
                <FormItem :label="$t('Ad.beginDate')">
                  <span>{{form.beginDate}}</span>
                </FormItem>
                <FormItem :label="$t('Ad.endDate')">
                  <span>{{form.endDate}}</span>
                </FormItem>
                <FormItem :label="$t('sort')">
                  <span>{{form.sort_id}}</span>
                </FormItem>
                <FormItem :label="$t('Info.url')+' - PC'">
                  <span>{{form.url_link}}</span>
                </FormItem>
                <FormItem :label="$t('Info.url')+' - Mobile'">
                  <span>{{form.mobile_link_url}}</span>
                </FormItem>
                <FormItem :label="$t('type')">
                  <span>{{form.type_cdesc}}</span>
                </FormItem>
                <FormItem :label="$t('isJump')">
                  <span>{{form.link_status == 0 ? $t('close'):$t('enabled')}}</span>
                </FormItem>
                <FormItem :label="$t('external_link')">
                  <span>{{form.link_type == 0 ? $t('close'):$t('enabled')}}</span>
                </FormItem>
                <FormItem :label="$t('status')">
                  <span>{{form.status == 0 ? $t('close'):$t('enabled')}}</span>
                </FormItem>
              </Col>
            </Row>
          </Tabs>
        </Form>
      </div>
      <div slot="footer">
        <Button @click="cancel()">{{$t('back')}}</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
export default {
  props: {
    modal: {
      type: Boolean,
      default: false,
    },
    itemObj: Object,
  },
  data () {
    return {
      tabs: '1',
      form: {
        ad_item_id: "",
        ad_id: "",
        sort_id: null,
        begin_date: "",
        end_date: "",
        url_link: "",
        status: "0",
        mobile_link_url: "",
        link_status: "0",
        link_type: "0",
        ad_type: "0",
        "zh-cn_cname": "",
        "zh-cn_cdesc": "",
        "zh-cn_image": "",
        "zh-cn_button": "",
        "zh-tw_cname": "",
        "zh-tw_cdesc": "",
        "zh-tw_image": "",
        "zh-tw_button": "",
        en_cname: '',
        en_cdesc: "",
        en_image: "",
        en_button: "",
        beginDate: "",
        endDate: "",
        "zh-tw_mobile_img": "",
        "zh-cn_mobile_img": "",
        en_mobile_img: ""
      },
      show: this.modal
    }

  },
  created () {
    this.info()
  },
  mounted () {

  },
  methods: {
    info () {
      this.form.ad_id = this.$base.getRequest().id
      if (this.type != 'add') {
        this.$base.showLoading();
        this.$request.sendPost(
          'ad-blog/before-upd',
          { ad_item_id: this.itemObj.ad_item_id },
          (success, data, error) => {
            this.$base.hideLoading();
            if (!success) return this.$base.alertErr(error.errmsg);
            this.form = data.info
            this.form.sort_id = this.form.sort_id * 1
            this.form.beginDate = data.info.begin_date;
            this.form.endDate = data.info.end_date;
          }
        );
      }
    },

    cancel () {
      this.$emit('cancel');
    },
    ontabs (item) {
      this.tabs = item
    },
  }
}
</script>

<style lang="less" scoped>
/deep/ .modal {
  .list {
    width: 100%;
    padding: 30px;
  }
  .ivu-tabs-nav-scroll {
    display: flex;
    justify-content: center;
  }
  .demo-upload-list {
    display: inline-block;
    width: 300px;
    height: 150px;
    text-align: center;
    line-height: 100px;
    border: 1px solid transparent;
    border-radius: 4px;
    overflow: hidden;
    background: #fff;
    position: relative;
    margin-right: 4px;
  }
  .demo-upload-list img {
    width: 100%;
    height: 100%;
    border: 1px solid #dcdee2;
  }
  .ivu-upload-drag {
    height: 150px;
  }
  .ivu-btn-small {
    height: 24px;
    padding: 0 7px;
    font-size: 14px;
    border-radius: 3px;
  }
  .ivu-tabs {
    overflow: inherit;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/edu/blogAd/module/ad_info.vue